import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";
import {
  selectConversationSearchLoading,
  selectConversationSearchLoadingMore,
  selectConversationSearchQuery,
  selectConversationSearchStatus,
  selectConversationsLoading,
  selectConversationsLoadingMore,
  selectInboxConversations,
} from "./messagingSlice";

const useInboxConversationList = () => {
  const { t } = useTranslation("messaging");
  const searchQuery = useAppSelector(selectConversationSearchQuery);
  const searchStatus = useAppSelector(selectConversationSearchStatus);
  const conversations = useAppSelector(selectInboxConversations);
  const tabLoading = useAppSelector(selectConversationsLoading);
  const tabLoadingMore = useAppSelector(selectConversationsLoadingMore);
  const searchLoading = useAppSelector(selectConversationSearchLoading);
  const searchLoadingMore = useAppSelector(
    selectConversationSearchLoadingMore,
  );
  const searching = Boolean(searchQuery);
  const loading = searching ? searchLoading : tabLoading;
  const loadingMore = searching ? searchLoadingMore : tabLoadingMore;
  const emptyLabel =
    searching && !loading && !loadingMore && conversations.length === 0
      ? t(searchStatus === "failed" ? "searchFailed" : "searchEmpty")
      : undefined;

  return { conversations, loading, loadingMore, emptyLabel, searching };
};

export default useInboxConversationList;
